import { Component, OnInit, Inject, Renderer2, OnDestroy, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CoreService } from 'src/app/core/helpers/core.service';
import { AuthService } from 'src/app/core/helpers/auth.service';
import { GaService } from '../../core/helpers/ga.service';
import { LocalizationService } from 'src/app/core/helpers/localization.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { LegalModalsService } from '../shared/services/legal-modals.service';

import { ToastrService } from 'ngx-toastr';
import { HttpParams } from '@angular/common/http';

@Component({
  selector: 'loyaltic-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {
  @ViewChild('forgotPassword', { static: false }) forgotPasswordRef: any;

  popupConfig = {
    ignoreBackdropClick: true,
    class: 'lyltc win modal-md modal-dialog-centered',
  };


  availableGamesCount = 0;
  userId = '';
  uploadType = '';
  type = '';
  phoneNumber = '';
  confirmedPhoneNumber = '';
  IsAcceptTerms = false;
  Email = '';
  isLoggedIn = false;
  hasOptedForMarkettingEmail = false;
  isShowForgotPassword = false;
  showStoreSelection = false;
  resetEmail = '';
  public modalRef: BsModalRef;
  stores: any[] = [];
  logoUrl = '';



  constructor(
    @Inject('ImagePath') public ImagePath,
    public translate: TranslateService,
    private router: Router,
    private authService: AuthService,
    private gaService: GaService,
    private renderer: Renderer2,
    private modalService: BsModalService,
    private legalModalsService: LegalModalsService,
  ) {
    this.authService.getAuthentication().subscribe((response:any) => {
      this.isLoggedIn = response.isAuthenticated;
    })

   
  }
  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }
  ngOnDestroy(): void {
    this.renderer.removeClass(document.body, 'body-home');
  }

  showForgotPassword() {
    this.modalRef = this.modalService.show(this.forgotPasswordRef, this.popupConfig);

  }

  ngOnInit() {
    if (this.authService.getUserId() !== null) {
      this.isLoggedIn = true;
    } else {
      this.isLoggedIn = false;
    }
    this.renderer.addClass(document.body, 'body-home');
  } 

  play() {
    let url = localStorage.getItem('gameurl');
    this.gaService.emitEvent('gameplays', 'Register Screen');
    window.open(url, '_self');
  }


  captureImage() {
    this.router.navigate(['/captureImage'])
  }

  openRulesModal() {
    this.legalModalsService.openRules();
  }

  openPolicyModal() {
    this.legalModalsService.openPolicy();
  }

}
